import { useEffect } from 'react';
import Head from 'react-helmet';

import RenterProfileForm from 'app/shared/modules/RenterProfileForm';
import RoleCheck from 'app/shared/wrappers/RoleCheck';
import Row from 'app/shared/core/Row';
import UserSettingsTabs from 'app/shared/modules/user-dashboard/UserSettingsTabs';

import { SettingsPageContainer } from './styles';
import { useDispatch } from 'react-redux';
import { emitTrackViewSettingsPageEvent } from 'app/shared/models/Clickstream/PageViewEvents';

const UserRenterProfilePage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    emitTrackViewSettingsPageEvent({
      triggerLocation: 'renter_profile',
      triggerSource: 'renter_profile',
    });
  }, [dispatch]);

  return (
    <SettingsPageContainer>
      <Head title="Renter Profile | HotPads" />
      <UserSettingsTabs />
      <Row>
        <RenterProfileForm />
      </Row>
    </SettingsPageContainer>
  );
};

export default RoleCheck({ roleReq: 'user', verifiedReq: true })(UserRenterProfilePage);
